import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Debug from 'debug';
import { IFinancialLineItem } from '../../../interfaces/settings.interface';
import { TemplatesProvider } from '../../../provider/templates.provider';
import { BaseComponent } from '../../base.component';

const debug = Debug('aumico:aumico-lib-templates-fe:FinancialLineItemsListComponent');

@Component({
    selector: 'financial-line-items',
    templateUrl: 'financial-line-items-list.component.html',
    styleUrls: ['financial-line-items-list.component.scss'],
})
export class FinancialLineItemsListComponent extends BaseComponent implements OnInit {
    financialLineItems = [];

    constructor(
        public override templatesProvider: TemplatesProvider,
        @Inject(MAT_DIALOG_DATA) private data: { financialLineItems: IFinancialLineItem[] },
        private dialogRef: MatDialogRef<FinancialLineItemsListComponent>,
    ) {
        super(templatesProvider);
    }

    override ngOnInit() {
        super.ngOnInit();
        this.financialLineItems = this.data.financialLineItems;
    }

    save() {
        let selectedfinancialLineItems = this.financialLineItems.filter((fli) => fli.selected);
        selectedfinancialLineItems = selectedfinancialLineItems.map((fli) => {
            delete fli.selected;
            return fli;
        });
        this.closeDialog(selectedfinancialLineItems);
    }

    closeDialog(data?: IFinancialLineItem[]) {
        this.financialLineItems = this.financialLineItems.map((fli) => {
            delete fli.selected;
            return fli;
        });
        if (typeof this.dialogRef === 'object' && !(Object.keys(this.dialogRef).length === 0)) {
            this.dialogRef.close(data);
        }
    }
}
